import { render } from "./ResponseTheme.vue?vue&type=template&id=5f121e86&scoped=true"
import script from "./ResponseTheme.vue?vue&type=script&lang=js"
export * from "./ResponseTheme.vue?vue&type=script&lang=js"

import "./ResponseTheme.vue?vue&type=style&index=0&id=5f121e86&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f121e86"]])

export default __exports__